var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"my-5 text-center"},[_c('h1',[_vm._v("Uh oh...")]),_c('h3',[_vm._v("The "+_vm._s(_vm.props.resource)+" you were looking for was not found.")])])}
var staticRenderFns = []

export { render, staticRenderFns }